import {get, post} from '../index'

export default {
  // 获取客户列表
  getCustomerList (querys) {
    return get('/customer/admin/customers', querys)
  },
  // 获取客户详情信息
  getCoustomerInfo (querys) {
    return post('/customer/admin/customer', querys)
  },
  // 分配客户
  distributionCustomer (querys) {
    return post('/customer/admin/allot', querys)
  },
  // 客户调查
  getCustomerLookIntoInfo (querys) {
    return get('/customer/admin/getCustomerQuestionnaire', querys)
  },
  // 话术分类列表
  getCustomerTalkClassifyList (querys) {
    return get('/customer/admin/replyTypes', querys)
  },
  // 添加话术分类
  addCustomerTalkClassifyInfo (querys) {
    return post('/customer/admin/addReplyType', querys)
  },
  // 修改话术分类
  editCustomerTalkClassifyInfo (querys) {
    return post('/customer/admin/updateReplyType', querys)
  },
  // 删除话术分类
  delCustomerTalkClassifyInto (querys) {
    return get('/customer/admin/delReplyType', querys)
  },
  // 话术列表
  getCustomerTalkList (querys) {
    return get('/customer/admin/reply', querys)
  },
  // 添加话术信息
  addCustomerTalkInfo (querys) {
    return post('/customer/admin/addReply', querys)
  },
  // 修改话术信息
  editCustomerTalkInfo (querys) {
    return post('/customer/admin/updateReply', querys)
  },
  // 删除话术信息
  delCustomerTalkInfo (querys) {
    return get('/customer/admin/delReply', querys)
  },
  // 问卷调查列表
  getCustomerQuestionsList (querys) {
    return get('/customer/admin/questionnairs', querys)
  },
  // 问卷调查详情
  getCustomerQuestionDetail (querys) {
    return get('/customer/admin/questionnair', querys)
  },
  // 添加问卷
  addCustomerQuestionInfo (querys) {
    return post('/customer/admin/addQuestionnair', querys)
  },
  // 编辑问卷调查
  editCustomerQuestionInfo (querys) {
    return post('/customer/admin/updateQuestionnair', querys)
  },
  // 删除问卷调查
  delCustomerQuestionInfo (querys) {
    return post('/customer/admin/delQuestionnair', querys)
  },
  // 获取问卷调查的配置详情
  getCustomerQuestionConfigInfo () {
    return get('/customer/admin/questionnairConfig')
  },
  // 设置问卷调查的配置信息
  settingCustomerQuestionConfigInfo (querys) {
    return post('/customer/admin/questionnairConfig', querys)
  },
  // 员工交接
  customerHandover (querys) {
    return post('/customer/admin/handover', querys)
  },
  // 获取分配员工的客户列表
  getStaffsFollowCustomerId (querys) {
    return get('customer/admin/allot', querys)
  },
  // 获取分配员工的客户列表
  importCustomer (querys) {
    return post('customer/admin/importCustomer', querys)
  },
  // 下载模版
  getExcelPath (querys) {
    return post('/customer/admin/getExcelPath', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/customer.js